/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getEventStatusForEventId } from '@xanadu/ui-shared/modules/event/selectors';
import { getStream } from '@xanadu/ui-shared/modules/streaming/actions';
import { StreamInfo } from '@xanadu/ui-shared/modules/streaming/reducer';
import { loginRequest } from '@xanadu/ui-shared/modules/userSession/actions';

import Streaming from '../../components/Streaming';

const streamRecord = new StreamInfo();

const mapDispatchToProps = {
  loginRequest,
  getStream,
};

function mapStateToProps(state) {
  const eventId = state.getIn(['application', 'eventId']);
  const isClosed = getEventStatusForEventId(state, eventId);

  let matchedAmount = 0;
  state.get('bets').forEach((bet) => {
    if (bet.eventId === eventId) {
      matchedAmount += bet.stake;
    }
  });

  const streamInfo = state.getIn(['streaming', 'streamInfo', eventId], streamRecord);
  return {
    widthSize: state.getIn(['application', 'widthSize']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    rightSidebarVisible: state.getIn(['rightSidebar', 'visible']),
    streamDetails: state.getIn(['streaming', 'stream']),
    streamError: state.getIn(['streaming', 'streamError']),
    pipEnabled: state.getIn(['streaming', 'pipEnabled']),
    currentEvent: eventId,
    streamAvailable: streamInfo.eventId,
    minimumBetAmount: streamInfo.minimumBetAmount,
    pipEvent: state.getIn(['streaming', 'pipEvent']),
    matchedAmount,
    isClosed,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Streaming));
